import {observable, computed} from 'mobx';
import {RECORDING_MEDIA_TYPE} from '@techsee/techsee-common/lib/constants/recording.constants';

export interface IHistoryRecord {
    accountId: string;
    customerId?: string;
    customerNumber?: string;
    files: any[];
    images: any[];
    messages: any[];
    roomClosed: boolean;
    roomId: {_id: string};
    timestamp: string;
    videos: any[];
    recordings?: any[];
}

export const ALL_RECORDING_MEDIA_TYPES: string[] = [
    RECORDING_MEDIA_TYPE.VIDEO_AND_AUDIO,
    RECORDING_MEDIA_TYPE.VIDEO,
    RECORDING_MEDIA_TYPE.AUDIO
];

export interface IFilteredData {
    records: IHistoryRecord[];
    images: number;
    videos: number;
    messages: number;
    files: number;
    recordings: number;
}

export class HistoryState {
    @observable videoLink: string | null = null;

    @observable historyData: {
        records: IHistoryRecord[];
        hasVideoRecordings?: boolean;
    } = {
        records: []
    };

    @observable filteredData: IFilteredData = {
        records: [],
        images: 0,
        videos: 0,
        messages: 0,
        files: 0,
        recordings: 0
    };

    @observable recordings: any[] = [];

    @observable selectedMediaTypes: string[] = [...ALL_RECORDING_MEDIA_TYPES];

    @observable startDate: Date | null = null;

    @observable endDate: Date | null = null;

    @observable startDatePickerOpen: boolean = false;

    @observable endDatePickerOpen: boolean = false;

    @observable searchTagForm: {
        searchTerm: string;
        submitted: boolean;
    } = {
        searchTerm: '',
        submitted: false
    };

    @observable emptySearchTermSubmitted: boolean = false;

    @observable videoRecordings: any[] = [];

    @observable searchByTagsCount: number = 0;

    @observable customerId?: string;

    @observable customerNumber?: string;

    @observable searchByTags: boolean = false;

    @computed
    get hasRecords(): boolean {
        return this.filteredData.records.length > 0;
    }

    @computed
    get hasImages(): boolean {
        return this.filteredData.images > 0;
    }

    @computed
    get hasVideos(): boolean {
        return this.filteredData.videos > 0;
    }

    @computed
    get hasMessages(): boolean {
        return this.filteredData.messages > 0;
    }

    @computed
    get hasFiles(): boolean {
        return this.filteredData.files > 0;
    }

    @computed
    get hasRecordings(): boolean {
        return this.filteredData.recordings > 0;
    }
}
